import { DicoCtrl } from "./taskpane/dicoctrl";
declare const BUILD_DATE: string;
declare const APP_TITLE: string;
declare const RUNTIME_ENVIRONMENT: string;

document.addEventListener("DOMContentLoaded", () => {
  // depuis webpack, titre défini pour prod, test, ou dev
  // depuis webpack, afficher date de build
  document.title = APP_TITLE;
  const dateBuildDiv = document.getElementById("dateBuild");
  if (dateBuildDiv) {
    const buildDate = new Date(BUILD_DATE).toLocaleDateString("fr-FR");
    console.log(RUNTIME_ENVIRONMENT);
    // Déterminer le style du badge selon l'environnement
    let envBadge = "";
    if (RUNTIME_ENVIRONMENT === "dev") {
      envBadge = '<span class="badge bg-warning text-dark">DEV</span>';
    } else if (RUNTIME_ENVIRONMENT === "test") {
      envBadge = '<span class="badge bg-info text-dark">TEST</span>';
    }

    dateBuildDiv.innerHTML = `
            <div class="col-12">
                ${envBadge}
                <label class="col-form-label-sm">Date de compilation: </label>
                <span class="form-control-sm">${buildDate}</span>
            </div>
        `;
  }
});

const dico = new DicoCtrl({
  selectId: "generatedSelectDiv2",
  whereToShowId: "whereToShow2",
  insertBtnId: "onlyActifBtn",
  searchBtnId: "searchbutton",
  searchBarId: "searchbar",
  excelWordSelectId: "excelWord",
  versionSelectId: "versionId",
  callback: (path, isGroup) => {
    const elements = path.split("/");
    if (!elements.length) return;
    const excelWord = (<HTMLInputElement>document.getElementById("excelWord")).value;
    if (!isGroup || (isGroup && excelWord === "word")) {
      const el = document.getElementsByClassName("actif");
      (<HTMLInputElement>document.getElementById("textareaToFill")).value += el[0].getAttribute("dataWeb");
    }
  },
}).init();
